<template>
	<div>
    <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
		<div class=" container-fluid">
        <div class="llp-container-section  heightcontainer ">
		<top-header id="height2"></top-header>
      <main-menu id="height3"></main-menu>
		<!-- Start the code for this screen here -->
		<div id="reporting" class="container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
			<div>
				<nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Data Report</b></span></nav>
				<br>
				<div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 ">
          <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center mb-2 mb-md-2 mb-lg-0 mb-sm-2 mr-0">
             <download-csv
            :name="customerexport"
            :title="CustomerExport"
            worksheet="Customer Data"
            :data="customerData"
          >
            <button
              class="btn btn-secondary"
            >Customer Export</button>
          </download-csv>
          </div>

						<vue-excel-xlsx class="btn btn-secondary mr-3" :filename="'Dealers Export'" :sheetname="'Dealers'" title="Dealers Extract" :data="dealerdata" :columns="dealer_search_fields_export"> Dealers </vue-excel-xlsx>

						<vue-excel-xlsx class="btn btn-secondary mr-3" :filename="'Dealers Contacts Export'" :sheetname="'Dealers'" title="Dealers Contacts Extract" :data="dealercontactdata" :columns="dealer_contact_fields_export"> Dealers Contacts </vue-excel-xlsx>

						<vue-excel-xlsx class="btn btn-secondary mr-3" :filename="'Dealers Activity Level Export'" :sheetname="'Dealers'" title="Dealers Activity Level Extract" :data="dealeractivitydata" :columns="dealer_fields_export"> Dealers Activity Level </vue-excel-xlsx>

				</div>
				<br>
				<nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Historical Data Report</b></span></nav>
				<br>
				 <center v-if="this.historicalDataMessage!=''">{{historicalDataMessage}}</center>
      	<div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 mb-5 mb-md-5 mb-sm-5">

        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <label for="source">Apps and Quotes</label>
        </div>
        <div class="col-12 col-lg-3 col-sm-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
           <select
            v-model.trim="historicalDataReport"
            @change="historicalReportType" class="form-control input-sm"
          >
            <option value disabled>Select</option>
            <option
              v-for="(option, index) in historicalData"
              v-bind:value="option.value"
              v-bind:key="index"
              >{{ option.name }}</option
            >
          </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <download-csv
            :name="historicalreport"
            :title="AdditionalReport"
            worksheet="Additional Reports"
            :data="exportHistoricalData"

          >
            <button
              class="btn btn-secondary mb-3 mb-lg-0"
            >Export CSV</button>
          </download-csv>

        </div>

     	 </div>

				<nav class="navbar navbar-expand-lg  bg-info text-white">
        <span>
          <b>Daily Extended Additional Reports</b>
        </span></nav>
      </div>
      <br />
	  <center v-if="this.reportMessage!=''">{{reportMessage}}</center>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 mb-5 mb-md-5 mb-sm-5">

        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <label for="source">Select Report Type</label>
        </div>
        <div class="col-12 col-lg-3 col-sm-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
          <select v-model.trim="reportType" @change="dmvReportType" class="form-control input-sm">
            <option value="" disabled>Select Report Type</option>
            <option
              v-for="(option,index) in reportTypeList"
              v-bind:value="option.value"
              v-bind:key="index"
            >{{option.name}}</option>
          </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <download-csv
            :name="report"
            :title="csvTitle"
            worksheet="Extended Reports"
            :data="exportdmvdata"

          >
            <button
              class="btn btn-secondary mb-3 mb-lg-0"
            >Export CSV</button>
          </download-csv>

        </div>

      </div>

	<nav class="navbar navbar-expand-lg  bg-info text-white">
        <span>
          <b>DMV Title Reports</b>
        </span></nav>
      </div>
      <br />
	  <center v-if="this.dmvReportMessage!=''">{{dmvReportMessage}}</center>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 mb-5 mb-md-5 mb-sm-5">

        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <label for="source">Select Report Type</label>
        </div>
        <div class="col-12 col-lg-3 col-sm-3 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
          <select v-model.trim="dmvTitleReport" @change="getdmvTitleReports" class="form-control input-sm">
            <option value="" disabled>Select Report Type</option>
            <option
              v-for="(option,index) in DMVReportTypeList"
              v-bind:value="option.value"
              v-bind:key="index"
            >{{option.name}}</option>
          </select>
        </div>
        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">

          <div v-if ="dmvTitleReport == 'title_report' ">

<button
             class="btn btn-secondary mb-3 mb-lg-0"    @click="getDMVTitleReportData"
            >Export</button>

		</div>

 <!-- <div v-if ="dmvTitleReport == 'dr_dmv_reminders' ">

<button
             class="btn btn-secondary mb-3 mb-lg-0"    @click="getDMVRemindersTitleReportData"
            >Export</button>

		</div> -->

<div v-if ="dmvTitleReport == 'clock_completion_report' ">

<button
             class="btn btn-secondary mb-3 mb-lg-0"    @click="getexportMilestoneData"
            >Export</button>

		</div>
<div v-if="dmvTitleReport != 'title_report' && dmvTitleReport != 'dr_dmv_reminders' && dmvTitleReport != 'clock_completion_report' ">
   <download-csv
            :name="dmvreport"
            :title="csvTitle"
            worksheet="Extended Reports"
            :data="dmvTitleReportsList"

          >
            <button
              class="btn btn-secondary mb-3 mb-lg-0"
            >Export</button>
          </download-csv>
</div>
        </div>

      </div>
      <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>DMV Reminders Report</b></span></nav>
		 <br>
 <center v-if="this.dmvRemindersReportMessage!=''" style="color:red">{{dmvRemindersReportMessage}}</center>
 <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2  p-2 mb-5 mb-md-5 mb-sm-5">

        <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <label for="source">From Date</label>
        </div>

  <input type="date" v-model="reminderFromDate"    class="form-control input-sm"
              name="DFrom"
             >
  <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
          <label for="source">To  Date</label>
        </div>
           <input type="date" v-model="reminderToDate"   class="form-control input-sm">
             <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
            <button
             class="btn btn-secondary mb-3 mb-lg-0"    @click="getDMVRemindersTitleReportData()"
            >Export</button>  </div>
        </div>

    </div></div>

		<!-- End of the code for this screen here -->
		<bottom-footer></bottom-footer>
        </div>
		</div>
	</div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import httpdeal from '../js/http-dealstracking.js'
import dataReporting from '../js/http-datareporting.js'
import httpcustomer from '../js/http-customer.js'
import manageSourceSvc from '../js/http-managesource'
import httpdmvtitle from '../js/http-dmvtitledata.js'
import moment from 'moment'
import axios from 'axios'
// Tested by Hanumanth
export default {
  components: { MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'datareport',
  data () {
    return {
      reminderFromDate: moment(new Date()).utc().format('YYYY-MM-DD'),
      reminderToDate: moment(new Date()).utc().format('YYYY-MM-DD'),
      dmvTitleReportsList: [],
      dmvTitleDataReportsList: [],
      dmvTitleReport: '',
      dmvTitleDataReport: '',
      dealerdata: [],
      dealercontactdata: [],
      exportdmvdata: [],
      dealeractivitydata: [],
      dmvdata: [],
      datareport: '',
      report: '',
      dmvreport: '',
      csvTitle: '',
      reportMessage: '',
      dmvReportMessage: '',
      dmvRemindersReportMessage: '',
      historicalDataReport: '',
      historicalData: [{ name: 'Apps', value: 'application' }, { name: 'Quotes', value: 'quote' }],
      historical_data_fileds_export: '',
      historicalDataMessage: '',
      exportHistoricalData: [],
      customerexport: 'Customers Data',
      customerData: [],
      isLoading: false,
      dealer_contact_fields_export: [
        {
          label: 'Dealer Name',
          field: 'dealerName'
        },
        {
          label: 'First Name',
          field: 'firstName'
        },
        {
          label: 'Middle Name',
          field: 'middleName'
        },
        {
          label: 'Last Name',
          field: 'lastName'
        },
        {
          label: 'Contact Title',
          field: 'contactTitle'
        },
        {
          label: 'Work Number',
          field: 'workNumber'
        },
        {
          label: 'Mobile Number',
          field: 'mobileNumber'
        },
        {
          label: 'Fax Number',
          field: 'faxNumber'
        },
        {
          label: 'Email',
          field: 'email'
        },
        {
          label: 'Contact Type',
          field: 'contactType'
        }

      ],

      dealer_search_fields_export: [

        {
          label: 'Dealer Name',
          field: 'dealerName'
        },
        {
          label: 'Address Line1',
          field: 'street1'
        },
        {
          label: 'Address Line2',
          field: 'street2'
        },
        {
          label: 'City',
          field: 'city'
        },
        {
          label: 'State',
          field: 'stateName'
        },
        {
          label: 'Zip Code',
          field: 'zipCode'
        },
        {
          label: 'Country',
          field: 'country'
        },
        {
          label: 'Status',
          field: 'dealerStatus'
        }

      ],
      dealer_fields_export: [
        {
          label: 'Dealer Name',
          field: 'dealerName'
        },
        {
          label: 'Address Line1',
          field: 'street1'
        },
        {
          label: 'Address Line2',
          field: 'street2'
        },
        {
          label: 'City',
          field: 'city'
        },
        {
          label: 'State',
          field: 'stateName'
        },
        {
          label: 'Zip Code',
          field: 'zipCode'
        },
        {
          label: 'Country',
          field: 'country'
        },
        {
          label: 'Status',
          field: 'dealerStatus'
        },
        {
          label: 'Dealer Activity Level',
          field: 'dealerActivityLevel'
        },
        {
          label: 'Quote Days Back',
          field: 'dealerDays'
        },
        {
          label: 'Employee First Name',
          field: 'firstName'
        },
        {
          label: 'Employee Last Name',
          field: 'lastName'
        },
        {
          label: 'Work Number',
          field: 'workNumber'
        },
        {
          label: 'Mobile Number',
          field: 'mobileNumber'
        },
        {
          label: 'Fax Number',
          field: 'faxNumber'
        },
        {
          label: 'Email',
          field: 'email'
        }

      ],
      dataYear: [],
      dataNames: [],
      dataDataAnalyticsOne: '',
      dataDataAnalyticsTwo: '',
      dataDataAnalyticsThree: '',
      dataDataAnalyticsFour: '',
      DataAnalyticsOne: '',
      DataAnalyticsTwo: '',
      DataAnalyticsThree: '',
      DataAnalyticsFour: '',
      allData: [],
      reportType: '',
      reportName: 'Unapplied Funds',
      dataMonth: [
        { text: '1', month: 'Jan' },
        { text: '2', month: 'Feb' },
        { text: '3', month: 'Mar' },
        { text: '4', month: 'Apr' },
        { text: '5', month: 'May' },
        { text: '6', month: 'Jun' },
        { text: '7', month: 'Jul' },
        { text: '8', month: 'Aug' },
        { text: '9', month: 'Sep' },
        { text: '10', month: 'Oct' },
        { text: '11', month: 'Nov' },
        { text: '12', month: 'Dec' }
      ],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      displayLink: '',
      displayAnalyticsOne: '',
      displayAnalyticsTwo: '',
      displayAnalyticsThree: '',
      displayAnalyticsFour: '',
      display: [],
      heads: [
        { name: 'Report Id' },
        // { name: 'Report Name'  },
        { name: 'Frequency' },
        { name: 'Info' },
        { name: 'Download Link' },
        { name: 'Report Name' },
        { name: 'Source Name' }
      ],
      otherLinkHeads: [
        { name: 'S.no' },
        { name: 'Application' },
        { name: 'Quote' }
      ],
      historicalreport: '',
      reportTypeList: [
        { name: 'Badbank Info', value: 'badbank_info' },
        { name: 'Deferred Down Expired', value: 'Deferred_DownExpired' },
        { name: 'Dmv Report', value: 'Dmv_Report' },
        { name: 'End Of Term', value: 'End_Of_Term' },
        { name: 'Expired Insurance', value: 'expired_insurance' },
        { name: 'First ACH Report', value: 'First_ACH_Report' },
        { name: 'Mileage Report', value: 'Mileage_Report' },
        { name: 'Missing Title Report', value: 'Missing_Title_Report' },
        { name: 'Newly Boarded Report', value: 'newly_boarded_report' },
        { name: 'Payoff Request', value: 'payoff_request' },
        { name: 'Recently Paid Off', value: 'Recently_PaidOff' },
        { name: 'Red Flag Monitoring Report', value: 'Red_Flag_Monitoring_Report' },
        { name: 'Salesperson Commission Report', value: 'salesperson_commission' },
        { name: 'Temporary Tag Report', value: 'temporary_tag_report' },
        { name: 'Titles Not At Trust', value: 'titles_not_at_trust' },
        { name: 'Unapplied Funds', value: 'unapplied_funds' }

      ],

      DMVReportTypeList: [
        { name: 'At service for processing', value: 'at_service_for_processing' },
        { name: 'DMV Financial Report', value: 'dmv_financial_report' },
        // {name:"DMV Reminders Report",value:"dr_dmv_reminders"},
        { name: 'DMV Report', value: 'dmv_autopal_report' },
        { name: 'DMV Notes Report', value: 'dmv_notes_report' },
        { name: 'Milestone Report', value: 'clock_completion_report' },
        { name: 'Paid Off Missing Title', value: 'paid_off_missing_title' },
        { name: 'Reg and Tags completed by service- waiting on the state to print title', value: 'reg_and tags_completed_by_service_waiting_on_the_state_to_print_title' },
        // {name:"Service Providers Report",value:"service_providers"},
        { name: 'Title in house, preparing to send to service', value: 'title_in_house_preparing_to_send_to_service' },
        { name: 'Title in house- holding for transfer to trust', value: 'dr_title_in_house_holding_for_transfer_to_trust' },
        { name: 'Title Reports', value: 'title_report' },
        { name: 'Temp Tag Report', value: 'dr_temp_tag_report' },
        { name: 'Waiting on paperwork from the lessee', value: 'waiting_on_paperwork_from_the_lessee' }

        // {name:"Titles At Trust",value:"title_at_trust"},
        // {name:"Title not received from the dealer",value:"title_not_received_from_the_dealer"},
        // {name:"The title is at trust DMV not completed",value:"the_title_is_at_trust_DMV_not_completed"},
        // {name:"SMOG Inspection Report",value:"smog_inspection"},
        // {name:"VIN Inspection Report",value:"vin_inspection"}

      ],

      dmv_fields_export: [],
      AdditionalReport: ''

    }
  },
  methods: {

    getDealersContcatsToExport () {
      manageSourceSvc.get('/dealercontacts').then(response => {
        this.dealercontactdata = response.data
      })
    },

    getCustomersToExport () {
      httpcustomer.get('/customer/customerExport').then(response => {
        this.customerData = response.data
      })
      this.customerexport = 'Customers_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
    },

    // Get Dealers for export
    getDealersToExport () {
      manageSourceSvc.get('/dealerreport').then(response => {
        this.dealeractivitydata = response.data
      })
    },
    getDealersSearchToExport () {
      manageSourceSvc.get('/dealerExtractReport').then(response => {
        this.dealerdata = response.data
      })
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#reporting').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },

    historicalReportType () {
      if (this.historicalDataReport == 'quote') {
        this.historical_data_fileds_export = this.Quotes_fields_export
        this.AdditionalReport = 'Historical Data'
        this.getAppsandQuotes()
        this.historicalreport = 'Quotes_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.historicalDataReport == 'application') {
        this.historical_data_fileds_export = this.apps_fields_export
        this.AdditionalReport = 'Historical Data'
        this.getAppsandQuotes()
        this.historicalreport = 'Applications_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      }
    },

    dmvReportType () {
      if (this.reportType == 'unapplied_funds') {
        this.dmv_fields_export = this.unappliedFunds
        this.dmvdatareport()
        this.csvTitle = 'Additional Reports'
        this.report = 'Unapplied_Funds_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'expired_insurance') {
        this.dmv_fields_export = this.expiredInsurance
        this.dmvdatareport()
        this.csvTitle = 'Additional Reports'
        this.report = 'Expired_Insurance_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'payoff_request') {
        this.dmv_fields_export = this.payoffRequest
        this.dmvdatareport()
        this.csvTitle = 'Additional Reports'
        this.report = 'Payoff_Request_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'badbank_info') {
        this.dmv_fields_export = this.badbankInfo
        this.dmvdatareport()
        this.csvTitle = 'Additional Reports'
        this.report = 'Badbank_Info_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'titles_not_at_trust') {
        this.dmv_fields_export = this.titlesNotAtTrust
        this.dmvdatareport()
        this.csvTitle = 'Additional Reports'
        this.report = 'Titles_NotAtTrust_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Recently_PaidOff') {
        this.dmv_fields_export = this.recently_Paidoff_fields_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Recently_Paidoff_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Deferred_DownExpired') {
        this.dmv_fields_export = this.deferred_downExpired_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Deferred_DownExpired_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'First_ACH_Report') {
        this.dmv_fields_export = this.first_ach_report_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'First_ACH_Report_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'End_Of_Term') {
        this.dmv_fields_export = this.end_of_term_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'End_Of_Term_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Red_Flag_Monitoring_Report') {
        this.dmv_fields_export = this.red_flag_monitoring_report_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Red_Flag_Monitoring_Report_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Missing_Title_Report') {
        this.dmv_fields_export = this.missing_title_report_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Missing_Title_Report_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'salesperson_commission') {
        this.dmvdatareport()
        this.csvTitle = 'Salesperson Commission'
        this.report = 'Salesperson_Commission_Report' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'temporary_tag_report') {
        this.dmvdatareport()
        this.csvTitle = 'Temporary Tag Report'

        this.report = 'Temporary_Tag_Report' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'newly_boarded_report') {
        this.dmvdatareport()
        this.csvTitle = 'Newly Boarded Report'
        this.report = 'Newly_Boarded_Report' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Dmv_Report') {
        this.dmv_fields_export = this.dmv_report_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Dmv_Report_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      } else if (this.reportType == 'Mileage_Report') {
        this.dmv_fields_export = this.mileage_report_export
        this.dmvdatareport()
        this.csvTitle = 'Extended And DMV Reports'
        this.report = 'Mileage_Report_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
      }
    },
    getAppsandQuotes () {
      this.isLoading = true
      this.exportHistoricalData = []
      let payload = {
        reportName: this.historicalDataReport
      }
      dataReporting.post(
        '/reports/getDataReports', payload).then(response => {
          this.isLoading = false
        if (response.data.length != 0) {
          this.historicalDataMessage = ''
          this.exportHistoricalData = response.data
        } else {
          this.historicalDataMessage = 'No records found in' + ' ' + this.historicalDataReport
        }
      }).catch(error=>{
            this.isLoading = false
            console.log(error)
        })
    },

    getdmvTitleReports () {
      this.dmvReportMessage = ''
      if (this.dmvTitleReport != 'title_report' && this.dmvTitleReport != 'dr_dmv_reminders' && this.dmvTitleReport != 'clock_completion_report') {
        this.dmvTitleReportsList = []
        let payload = {
          reportName: this.dmvTitleReport
        }

        console.log(this.dmvTitleReport)
        httpdmvtitle.post('/DMVTitle/getDMVReports', payload).then(response => {
          if (response.data.length != 0) {
            this.dmvReportMessage = ''
            this.dmvTitleReportsList = response.data

            this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
          } else {
            this.dmvTitleReportsList = []

            if (this.dmvTitleReport == 'waiting_on_paperwork_from_the_lessee') {
              httpdmvtitle.get('/DMVTitle/dmvTitleDocsReport/' + this.dmvTitleReport).then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else if (this.dmvTitleReport == 'dmv_financial_report') {
              httpdmvtitle.get('/DMVTitle/getFinancialReport').then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else if (this.dmvTitleReport == 'vin_inspection' || this.dmvTitleReport == 'smog_inspection') {
              let payload = {
                reportName: this.dmvTitleReport
              }
              httpdmvtitle.post('/DMVTitle/getDmvDocumentsReports', payload).then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else if (this.dmvTitleReport == 'service_providers') {
              let payload = {
                reportName: this.dmvTitleReport
              }
              httpdmvtitle.get('/DMVTitle/getdmvserviceProvider').then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else if (this.dmvTitleReport == 'dmv_notes_report') {
              let payload = {
                reportName: this.dmvTitleReport
              }
              httpdmvtitle.get('/dmvNotifications/getDMVNotesReport').then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  let dmvTitleReportsList = response.data                  
                  dmvTitleReportsList.map((element)=>{                    
                    element['Notes Creation Date'] = moment(element['Notes Creation Date']).format("YYYY-MM-DD HH:ss")
                  })   
                  this.dmvTitleReportsList = dmvTitleReportsList;                 
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else if (this.dmvTitleReport == 'dmv_autopal_report') {
              let payload = {
                reportName: this.dmvTitleReport
              }
              httpdmvtitle.get('/dmvNotifications/getDMVAutopalReport').then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            } else {
              httpdmvtitle.get('/DMVTitle/dmvTitleReport/' + this.dmvTitleReport).then(response => {
                if (response.data.length != 0) {
                  this.dmvReportMessage = ''
                  this.dmvTitleReportsList = response.data
                  this.dmvreport = this.dmvTitleReport + '_' + moment(new Date()).format('MM-DD-YYYY') + '.csv'
                } else {
                  this.dmvReportMessage = 'No records found in' + ' ' + this.dmvTitleReport
                }
              })
            }
          }
        })
      }
    },

    getDMVTitleReportData () {
      console.log("call herere");
      this.dmvReportMessage = ''
      httpdmvtitle.get(
        '/DMVTitle/titleReport/exportingTitleReport', {
          responseType: 'blob' }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Title Report' + moment(new Date()).format('MM-DD-YYYY') + '.XLSX')
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      })
    },

    getDMVRemindersTitleReportData () {
      if (this.reminderFromDate == '' && this.reminderToDate == '') {
        this.dmvRemindersReportMessage = 'Please select From Date and To Date'
      } else if (this.reminderFromDate == '' || this.reminderToDate == '') {
        this.dmvRemindersReportMessage = 'Please select From Date and To Date'
      } else {
        this.dmvRemindersReportMessage = ''
      }
      if (this.dmvRemindersReportMessage == '') {
        let payload = {
          fromDate: moment(new Date(this.reminderFromDate)).utc().format('YYYY-MM-DD'),
          toDate: moment(new Date(this.reminderToDate)).utc().format('YYYY-MM-DD')
        }
        httpdmvtitle.post(
          '/DMVTitle/exportReminders/dmvReminders', payload, {
            responseType: 'blob' }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Reminders Report' + moment(new Date()).format('MM-DD-YYYY') + '.XLSX')
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      }
    },

    getexportMilestoneData () {
      this.dmvReportMessage = ''
      httpdmvtitle.get(
        '/DMVTitle/exportMilestone/mileStone', {
          responseType: 'blob' }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Clock Completion Report' + moment(new Date()).format('MM-DD-YYYY') + '.XLSX')
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
      })
    },

    dmvdatareport () {
      let payLoad = {
        userName: this.$session.get('user_id'),
        userRole: this.$session.get('user_role'),
        reportType: this.reportType
      }
      let addtionalreport = {
        reportName: this.reportType
      }
      if (this.reportType == 'unapplied_funds' || this.reportType == 'expired_insurance' || this.reportType == 'payoff_request' ||
      this.reportType == 'badbank_info' || this.reportType == 'titles_not_at_trust') {
        this.exportdmvdata = []
        dataReporting.post(
          '/reports/getDataReports', addtionalreport).then(response => {
          if (response.data.length != 0) {
            this.reportMessage = ''
            this.exportdmvdata = response.data
          } else {
            this.reportMessage = 'No records found in' + ' ' + this.reportType
          }
        }
        )
      } else if (this.reportType == 'salesperson_commission' || this.reportType == 'temporary_tag_report' || this.reportType == 'newly_boarded_report') {
        this.exportdmvdata = []
        dataReporting.post(
          '/reports/getAdditionalDataReports', addtionalreport).then(response => {
          if (response.data.length != 0) {
            this.reportMessage = ''
            this.exportdmvdata = response.data
            console.log(this.exportdmvdata)
          } else {
            this.reportMessage = 'No records found' + ' ' + this.reportType
          }
        }
        )
      } else {
        this.exportdmvdata = []
        dataReporting.post(
          '/reports/getrecentpaidoff', payLoad).then(response => {
          if (response.data.length != 0) {
            this.reportMessage = ''
            this.exportdmvdata = response.data
          } else {
            this.reportMessage = 'No records found in' + ' ' + this.reportType
          }
        })
      }
    },

    clicked (app) {
      this.displayLink = window.open(app.reportLink, '_target')
    },
    clickOne: function () {
      this.displayAnalyticsOne = window.open(this.dataDataAnalyticsOne, '_target')
    },
    clickTwo: function () {
      this.displayAnalyticsTwo = window.open(this.dataDataAnalyticsTwo, '_target')
    },
    clickThree: function () {
      this.displayAnalyticsThree = window.open(this.dataDataAnalyticsThree, '_target')
    },
    clickFour: function () {
      this.displayAnalyticsFour = window.open(this.dataDataAnalyticsFour, '_target')
    },
    fetchData () {
      this.retrieveDataYear()
      this.retrieveDataMonth()
      this.retrieveDataNames()
      this.retrieveDataAnalytics()
      this.getDealersSearchToExport()
      this.getDealersContcatsToExport()
      this.getDealersToExport()
      this.getCustomersToExport()
    },
    retrieveDataYear: function () {
      httpdeal.get('/dataLinks/year').then(response => {
        this.dataYear = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveDataMonth: function () {
      httpdeal.get('/dataLinks/month').then(response => {
        // this.dataMonth = response.data
        // this.month = new Date().getMonth() + 1
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveDataNames: function () {
      httpdeal.get('/dataLinks/filename').then(response => {
        this.dataNames = response.data
        // this.month = new Date().getMonth() + 1
      })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrieveDataAnalytics: function () {
      httpdeal.get('/dataLinks/analytics').then(response => {
        this.dataDataAnalyticsOne = response.data.one
        this.dataDataAnalyticsTwo = response.data.two
        this.dataDataAnalyticsThree = response.data.threen
        this.dataDataAnalyticsFour = response.data.four
        this.DataAnalyticsOne = this.dataDataAnalyticsOne.split('?').slice(0, -1).toString().split('/').slice(-1).toString()
        this.DataAnalyticsTwo = this.dataDataAnalyticsTwo.split('?').slice(0, -1).toString().split('/').slice(-1).toString()
        this.DataAnalyticsThree = this.dataDataAnalyticsThree.split('?').slice(0, -1).toString().split('/').slice(-1).toString()
        this.DataAnalyticsFour = this.dataDataAnalyticsFour.split('?').slice(0, -1).toString().split('/').slice(-1).toString()
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    reset: function () {
      this.year = new Date().getFullYear(),
      this.month = new Date().getMonth() + 1,
      this.reportName = 'Unapplied Funds'
      let viewDealsPayload = {
        'year': this.year,
        // "month" : this.month,
        'reportName': this.reportName
      }
      // console.log(this.year)
      console.log(this.month)
      // console.log(this.reportName)
      httpdeal.post('/dataLinks/search', viewDealsPayload).then(response => {
        this.allData = response.data
        // console.log(JSON.stringify(this.allData))
      })
    },
    retrieveApplicationDetails: function () {
      let viewDealsPayload = {
        'year': this.year,
        'month': this.month,
        'reportName': this.reportName
      }
      // console.log(this.year)
      // console.log(this.reportName)
      httpdeal.post('/dataLinks/allsearch', viewDealsPayload).then(response => {
        this.allData = response.data
        // console.log(JSON.stringify(this.allData))
      })
    }
  },
  mounted () {
    this.fetchData()
    this.reset()
    this.myFunction()
    this.menuheight()
  },

  computed: {
    test_data () {
      var formatted = []
      for (let i = 0; i < this.allData.length; i++) {
        formatted[i] = this.allData[i].frequency
      }

      return formatted
    },
    test_data_reportLink () {
      var formatted = []
      for (let i = 0; i < this.allData.length; i++) {
        formatted[i] = this.allData[i].reportLink
      }
      return formatted
    }
  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  }
}
</script>

<style scoped>
.reportLink {
	cursor: pointer;
	color: blue;
	text-decoration: none;
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
